import React from 'react'
import PropTypes from 'prop-types'
import palette from 'theme/palette'

const StarIcon = ({ color = palette.dai.shinyBlue, size = 24, ...props }) => (
  <svg
    viewBox="0 0 36 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    style={{ display: 'inline-block', verticalAlign: 'middle' }}
    {...props}
  >
    <g clipPath="url(#staricon-clip)" fill={color}>
      <path d="M27.446 3.72l1.79-3.322a.745.745 0 011.317 0l1.789 3.323 3.267 1.82a.77.77 0 010 1.34L32.342 8.7l-1.79 3.322a.745.745 0 01-1.317 0L27.446 8.7l-3.267-1.82a.77.77 0 010-1.34l3.267-1.82zM9.657 14.037l4.72-8.772a1.966 1.966 0 013.48 0l4.72 8.772 8.624 4.801c1.376.764 1.376 2.775 0 3.54l-8.625 4.8-4.72 8.773a1.966 1.966 0 01-3.48 0l-4.72-8.772-8.624-4.802c-1.376-.764-1.376-2.774 0-3.539l8.625-4.8z" />
    </g>
    <defs>
      <clipPath id="staricon-clip">
        <path fill="#fff" d="M0 0h36v37H0z" />
      </clipPath>
    </defs>
  </svg>
)

StarIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default StarIcon
